import React, { Component } from 'react';
import { Button, Icon, Table, Form, Segment, Input, Loader, Popup, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../util/request';
import { fetchAcademicYears } from '../../../Lookups/util';
import { extractFileNameFromHeaders } from '../../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';
import { ExportReactCSV } from '../../../util/ExportCSV';
import SearchTableData from '../../../util/SearchTableData';
import ReactExport from 'react-data-export';

const fetchCourseWorkloadTypes = () => axios.get('course-workload-types');

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const courseTypes = [
    {
        key: 1,
        value: 1,
        text: 'Izborni'
    },
    {
        key: 2,
        value: 2,
        text: 'Obavezni'
    },
];


export default class workload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            addNewWorkload: false,
            workloadForEdit: {},
            editMode: null,
            main: null,
            WinterSemesterLectureNumber: 0,
            SummerSemesterLectureNumber: 0,
            WinterSemesterExerciseNumber: 0,
            SummerSemesterExerciseNumber: 0,
            WinterSemesterCourses: 0,
            SummerSemesterCourses: 0,


            courseBasics: [],
            course: null,

            orgUnits: [],
            orgUnit: null,

            semesters: [],
            semester: null,

            workloadTypes: [],
            courseWorkloadType: 2,

            academicYears: [],
            academicYear: null,
            currentAcademicYear: null,

            mandatory: 2,
            lectureNumber: null,
            exerciseNumber: null,
            comment: null,

            orgUnitErr: false,
            courseErr: false,
            semesterErr: false,
            courseWorkloadTypeErr: false,
            mandatoryErr: false,
            lectureNumberErr: false,
            exerciseNumberErr: false,
            academicYearErr: false,

            id: null,
            optLock: null,
            academicYearForReport: null,
            getReport: false,
            academicYearForReportErr: false,

            loading: true,

            results: [],
            excelData: [],
        };
        this.getWorkloads = this.getWorkloads.bind(this);
        this.deleteWorkload = this.deleteWorkload.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getCourseBasic = this.getCourseBasic.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.addCourse = this.addCourse.bind(this);
        this.edit = this.edit.bind(this);

        this.getReport = this.getReport.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }


    componentWillMount() {
        this.setState({
            person: JSON.parse(localStorage.getItem('person')),
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true'
        });


        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));

        axios.all([fetchCourseWorkloadTypes(), fetchAcademicYears()])
            .then(axios.spread((workloadTypesRes, academicYearsRes) => {
                const workloadTypes = workloadTypesRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                const academicYears = academicYearsRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                })).reverse();

                this.setState({
                    workloadTypes, academicYears
                }, () => {
                    axios.get('/academic-years/current')
                        .then(res => {
                            this.setState({ currentAcademicYear: res.data.id, academicYearForReport: res.data.id }, () => { this.getWorkloads(); });
                        });
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data results');
            });

        if (localStorage.getItem('orgUnit')) {
            this.getCourseBasic(localStorage.getItem('orgUnit'));
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
        }
        if (localStorage.getItem('academicYear')) {
            this.getSemesters(localStorage.getItem('academicYear'));
            this.setState({ academicYear: parseInt(localStorage.getItem('academicYear')) });
        }

        if (localStorage.getItem('semester')) {
            this.setState({ semester: parseInt(localStorage.getItem('semester')) });
        }
        // }
    }

    getWorkloads() {
        let obj = {};
        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            obj = {
                employee: {
                    id: JSON.parse(localStorage.getItem('employee')).id,
                    associateStaff: localStorage.getItem('associate') === 'true'
                },
                organizationalUnit: { id: parseInt(localStorage.getItem('orgUnitId')) }
            };
        } else {
            obj = {
                id: JSON.parse(localStorage.getItem('employee')).id,
                associateStaff: localStorage.getItem('associate') === 'true'
            };
        }
        axios({
            method: 'post',
            url: localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' ? `course-workload/by-employee/all/${this.state.academicYearForReport}` : `course-workload/by-employee/${this.state.academicYearForReport}`,
            data: { ...obj }
        })
            .then(res => {
                let WinterSemesterLectureNumber = 0;
                let WinterSemesterExerciseNumber = 0;
                res.data.filter(el => el.semester.name._key === 'winter semester').map(e => (
                    WinterSemesterLectureNumber += e.lectureNumber,
                    WinterSemesterExerciseNumber += e.exerciseNumber
                ));

                let SummerSemesterLectureNumber = 0;
                let SummerSemesterExerciseNumber = 0;
                res.data.filter(el => el.semester.name._key === 'summer semester').map(e => (
                    SummerSemesterLectureNumber += e.lectureNumber,
                    SummerSemesterExerciseNumber += e.exerciseNumber
                ));
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        orgUnitName: el.courseBasicNew.organizationalUnit.name,
                        courseBasicName: el.courseBasicNew.name,
                        semesterName: el.semester.name.name,
                        academicYear: el.semester.academicYear.name,
                        workloadTypeName: el.courseWorkloadType.name,
                        courseType: el.mandatory ? 'Obavezni' : 'Izborni'
                    })),
                    SummerSemesterLectureNumber,
                    SummerSemesterExerciseNumber,
                    WinterSemesterExerciseNumber,
                    WinterSemesterLectureNumber,
                    WinterSemesterCourses: res.data.filter(el => el.semester.name._key === 'winter semester').length,
                    SummerSemesterCourses: res.data.filter(el => el.semester.name._key === 'summer semester').length,
                    loading: false
                });

                const excelData = res.data.map(el => ([
                    { value: el.courseBasicNew.organizationalUnit.name },
                    { value: el.courseBasicNew.name },
                    { value: el.semester.name.name },
                    { value: el.semester.academicYear.name },
                    { value: el.courseWorkloadType.name },
                    { value: el.lectureNumber },
                    { value: el.exerciseNumber },
                    { value: el.mandatory ? 'Obavezni' : 'Izborni' },
                    { value: el.comment ? el.comment : '' },
                ]));
                this.setState({ excelData });
            })
            .catch(err => {
                console.log('Failed to fetch workloads.');
            });
    }

    deleteWorkload(id) {
        let obj = { id };
        axios.delete('course-workload/delete/', { data: obj })
            .then(res => {
                toast('Uspješno ste obrisali predmet.');
                this.getWorkloads();
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje predmeta nije uspjelo.');
            });
    }


    getCourseBasic(orgUnitId) {
        axios.get(`course-basic-new/${orgUnitId}/`)
            .then(res => {
                const courseBasics = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ courseBasics });
            })
            .catch(err => {
                console.log('Failed to fetch course basics.');
            });
    }

    getSemesters(academicYear) {
        axios.get(`semester/by-academic-year/${academicYear}`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name
                    })).filter(e => e.name.name !== 'ostalo')
                });
            });
    }

    addCourse() {
        if (!this.state.orgUnit || !this.state.course || !this.state.academicYear || !this.state.semester || !this.state.courseWorkloadType || !this.state.mandatory || !this.state.lectureNumber || !this.state.exerciseNumber) {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.orgUnit) { this.setState({ orgUnitErr: true }); } else { this.setState({ orgUnitErr: false }); }
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.courseWorkloadType) { this.setState({ courseWorkloadTypeErr: true }); } else { this.setState({ courseWorkloadTypeErr: false }); }
            if (!this.state.mandatory) { this.setState({ mandatoryErr: true }); } else { this.setState({ mandatoryErr: false }); }
            if (!this.state.lectureNumber) { this.setState({ lectureNumberErr: true }); } else { this.setState({ lectureNumberErr: false }); }
            if (!this.state.exerciseNumber) { this.setState({ exerciseNumberErr: true }); } else { this.setState({ exerciseNumberErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
        } else {
            this.setState({
                orgUnitErr: false, courseErr: false, semesterErr: false, courseWorkloadTypeErr: false, mandatoryErr: false, lectureNumberErr: false, exerciseNumberErr: false, academicYearErr: false
            });
            let mandatory = null;
            if (this.state.mandatory === 1) mandatory = false;
            else mandatory = true;
            let obj = {
                employeeId: JSON.parse(localStorage.getItem('employee')).id,
                courseWorkloadTypeId: this.state.courseWorkloadType,
                courseBasicNewId: this.state.course,
                semesterId: this.state.semester,
                mandatory,
                lectureNumber: this.state.lectureNumber,
                exerciseNumber: this.state.exerciseNumber,
                comment: this.state.comment

            };
            axios.post('course-workload/add/', { ...obj })
                .then(res => {
                    toast('Dodavanje predmeta je uspješno izvršeno.');
                })
                .then(res => {
                    this.setState({
                        addNewWorkload: false, exerciseNumber: null, lectureNumber: null, comment: null, course: null
                    });
                    this.getWorkloads();
                })
                .catch(err => {
                    console.log('Failed to add course on workload');
                    toast('Došlo je do greške! Dodavanje predmeta nije uspješno izvršeno.');
                });
        }
    }

    edit() {
        if (!this.state.orgUnit || !this.state.course || !this.state.academicYear || !this.state.semester || !this.state.courseWorkloadType || !this.state.mandatory || this.state.lectureNumber === null || this.state.exerciseNumber === null || this.state.lectureNumber === '' || this.state.exerciseNumber === '') {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.orgUnit) { this.setState({ orgUnitErr: true }); } else { this.setState({ orgUnitErr: false }); }
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.courseWorkloadType) { this.setState({ courseWorkloadTypeErr: true }); } else { this.setState({ courseWorkloadTypeErr: false }); }
            if (!this.state.mandatory) { this.setState({ mandatoryErr: true }); } else { this.setState({ mandatoryErr: false }); }
            if (this.state.lectureNumber === null || this.state.lectureNumber === '') { this.setState({ lectureNumberErr: true }); } else { this.setState({ lectureNumberErr: false }); }
            if (this.state.exerciseNumber === null || this.state.exerciseNumber === '') { this.setState({ exerciseNumberErr: true }); } else { this.setState({ exerciseNumberErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
        } else {
            this.setState({
                orgUnitErr: false, courseErr: false, semesterErr: false, courseWorkloadTypeErr: false, mandatoryErr: false, lectureNumberErr: false, exerciseNumberErr: false, academicYearErr: false
            });
            let mandatory = null;
            if (this.state.mandatory === 1) mandatory = false;
            else mandatory = true;
            let obj = {
                employeeId: JSON.parse(localStorage.getItem('employee')).id,
                courseWorkloadTypeId: this.state.courseWorkloadType,
                courseBasicNewId: this.state.course,
                semesterId: this.state.semester,
                mandatory,
                lectureNumber: this.state.lectureNumber,
                exerciseNumber: this.state.exerciseNumber,
                comment: this.state.comment,
                id: this.state.id,
                optLock: this.state.optLock

            };
            axios.put('course-workload/edit/', { ...obj })
                .then(res => {
                    toast('Izmjena predmeta je uspješno izvršena.');
                })
                .then(res => {
                    this.setState({
                        editMode: null, exerciseNumber: null, lectureNumber: null, comment: null, course: null
                    });
                    this.getWorkloads();
                })
                .catch(err => {
                    console.log('Failed to add course on workload');
                    toast('Došlo je do greške! Dodavanje predmeta na opterećenje nije uspješno izvršeno.');
                });
        }
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'academicYearForReport') { this.getWorkloads(); this.setState({ addNewWorkload: false, editMode: null }); }
        });

        if (name === 'orgUnit') { localStorage.setItem('orgUnit', value); this.getCourseBasic(value); }
        if (name === 'academicYear') { localStorage.setItem('academicYear', value); this.getSemesters(value); }
        if (name === 'orgUnit') { localStorage.setItem('academicYear', value); }
        if (name === 'semester') { localStorage.setItem('semester', value); }
    }

    getReport() {
        if (!this.state.academicYearForReport) {
            this.setState({ academicYearForReportErr: true });
            toast('Morate odabrati akademsku godinu za koju želite izvještaj.');
        } else {
            this.setState({ academicYearForReportErr: false });

            let obj = {
                employeeId: this.state.employee.id,
                academicYearId: this.state.academicYearForReport,
                language: 'bs'
            };
            axios({
                method: 'post',
                url: '/documents/employee-workload-report',
                responseType: 'blob',
                data: { ...obj }
            })
                .then(res => {
                    if (res.data.size === 0) {
                        return;
                    }
                    const fileName = extractFileNameFromHeaders(res.headers);
                    download(res.data, fileName);
                    return res;
                })
                .catch(err => {
                    toast('Došlo je do greške! Zahtjev nije obrađen.');
                });
        }
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }


    render() {
        const headersForExport = [
            { label: 'Org. jedinica', key: 'orgUnitName' },
            { label: 'Predmet', key: 'courseBasicName' },
            { label: 'Semestar', key: 'semesterName' },
            { label: 'Akademska godina', key: 'academicYear' },
            { label: 'Tip zaduženja', key: 'workloadTypeName' },
            { label: 'P', key: 'lectureNumber' },
            { label: 'V', key: 'exerciseNumber' },
            { label: 'Tip predmeta', key: 'courseType' },
            { label: 'Napomena', key: 'comment' }
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 300 } },
                    { title: 'Predmet', width: { wpx: 400 } },
                    { title: 'Semestar', width: { wpx: 150 } },
                    { title: 'Akademska godina', width: { wpx: 150 } },
                    { title: 'Tip zaduženja', width: { wpx: 150 } },
                    { title: 'Predavanja', width: { wpx: 100 } },
                    { title: 'Vježbe', width: { wpx: 100 } },
                    { title: 'Tip predmeta', width: { wpx: 100 } },
                    { title: 'Napomena', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];
        const { editMode, addNewWorkload, getReport } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>

                {(this.state.main || localStorage.getItem('associate') === 'true' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') &&

                    <div>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite akademsku godinu"
                                        value={this.state.academicYearForReport}
                                        onChange={this.handleInputChange}
                                        name="academicYearForReport"
                                        options={this.state.academicYears}
                                        search
                                        error={this.state.academicYearForReportErr}
                                    />
                                </Form.Field>
                                <Form.Field />
                                {/* <Form.Button color="blue" icon labelPosition="left" floated="right" onClick={this.getReport}><Icon name="print" />Štampanje izvještaja</Form.Button> */}

                            </Form.Group>
                        </Form>
                    </div>}


                {/* {this.state.addNewWorkload && */}
                {/* <AddCourseOnWorkload */}
                {/* employeeId={JSON.parse(localStorage.getItem('employee')).id} */}
                {/* closeForm={() => {this.setState({ addNewWorkload: false }); this.getWorkloads();}} */}
                {/* />} */}

                {/* {this.state.editMode && */}
                {/* <AddCourseOnWorkload */}
                {/* editMode */}
                {/* employeeId={JSON.parse(localStorage.getItem('employee')).id} */}
                {/* workloadForEdit={this.state.workloadForEdit} */}
                {/* closeForm={() => {this.setState({ editMode: null }); this.getWorkloads();}} */}
                {/* />} */}

                {/* (this.state.data.length || addNewWorkload) ? */}
                <Table structured celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={((this.state.main || localStorage.getItem('associate') === 'true')
                            && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') ? 17 : 15}
                            >
                                <span>
                                    <span>
                                        <Grid stackable columns={2} >

                                            <Grid.Column width={12}>
                                                <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['orgUnitName', 'courseBasicName', 'semesterName', 'academicYear', 'workloadTypeName', 'courseType']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} style={{ paddingRight: '5px' }}>
                                                <Popup
                                                    trigger={
                                                        <Button
                                                            animated="vertical"
                                                            floated="right"
                                                            color="red"
                                                            basic
                                                            fluid
                                                            onClick={this.getReport}
                                                        >
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                PDF
                                                            </Button.Content>
                                                        </Button>
                                                    }
                                                    content="Preuzmi spisak u PDF-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>
                                            <Grid.Column width={2} style={{ paddingLeft: '5px' }}>

                                                {this.state.data &&
                                                <ExcelFile
                                                    filename="Opterećenje"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={multiDataSet} name="Zaposlenici" />
                                                </ExcelFile>}
                                                {/* // <ExportReactCSV color="green" csvData={ this.getDataToRender()} headers={headersForExport} floated="right" fileName="Spisak studenata na predmetu" fluid /> */}
                                            </Grid.Column>
                                        </Grid>

                                    </span>
                                </span>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan={3}>Org. jedinica</Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Predmet</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Semestar</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Tip zaduženja</Table.HeaderCell>
                            <Table.HeaderCell >P / V</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Tip predmeta</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Napomena</Table.HeaderCell>
                            {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:')
                            &&
                            <Table.HeaderCell colSpan={2} as="th" verticalAlign="middle" textAlign="center">
                                {(!this.state.addNewWorkload && !this.state.editMode && (this.state.main || localStorage.getItem('associate') === 'true'))
                                && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' && <Button
                                    disabled={this.state.currentAcademicYear !== this.state.academicYearForReport}
                                    icon="add"
                                    size="small"
                                    basic="true"
                                    color="blue"
                                    circular
                                    onClick={() => this.setState({ addNewWorkload: true, editMode: null })}
                                />}
                            </Table.HeaderCell>
                            }
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {addNewWorkload && <Table.Row>
                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                <Form noValidate>
                                    <Form.Field required error={this.state.orgUnitErr}>
                                        <Form.Dropdown
                                            selection
                                            placeholder="Odaberite fakultet"
                                            value={this.state.orgUnit}
                                            onChange={this.handleInputChange}
                                            name="orgUnit"
                                            options={this.state.orgUnits.filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet')}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                <Form noValidate>
                                    <Form.Field required disabled={!this.state.orgUnit} error={this.state.courseErr}>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite predmet"
                                            value={this.state.course}
                                            onChange={this.handleInputChange}
                                            name="course"
                                            options={this.state.courseBasics}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                <Form noValidate>
                                    <Form.Field required error={this.state.academicYearErr}>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite akademsku godinu"
                                            value={this.state.academicYear}
                                            onChange={this.handleInputChange}
                                            name="academicYear"
                                            options={this.state.academicYears.filter(year => year.id === this.state.currentAcademicYear)}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        required
                                        disabled={!this.state.academicYear}
                                        error={this.state.semesterErr}
                                    >
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite semestar"
                                            value={this.state.semester}
                                            onChange={this.handleInputChange}
                                            name="semester"
                                            options={this.state.semesters}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                <Form noValidate>
                                    <Form.Field required error={this.state.courseWorkloadTypeErr}>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite zaduženje"
                                            value={this.state.courseWorkloadType}
                                            onChange={this.handleInputChange}
                                            name="courseWorkloadType"
                                            options={this.state.workloadTypes}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field required error={this.state.lectureNumberErr}>
                                        <label>P</label>
                                        <input
                                            value={this.state.lectureNumber}
                                            onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                                            name="lectureNumber"
                                            // type='number'
                                            placeholder="P"
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.exerciseNumberErr}>
                                        <label>V</label>
                                        <input
                                            value={this.state.exerciseNumber}
                                            onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                                            name="exerciseNumber"
                                            // type='number'
                                            placeholder="V"
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                <Form noValidate>
                                    <Form.Field required error={this.state.mandatoryErr}>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite tip predmeta"
                                            value={this.state.mandatory}
                                            onChange={this.handleInputChange}
                                            name="mandatory"
                                            options={courseTypes}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                <Form noValidate>
                                    <Form.Field
                                        control={Input}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite napomenu..."
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={2}>
                                <Button
                                    color="blue"
                                    icon="check"
                                    circular
                                    onClick={() => this.addCourse()}
                                />
                                <Button
                                    basic="true"
                                    color="blue"
                                    icon="close"
                                    circular
                                    onClick={() => this.setState({
                                        addNewWorkload: false,
                                        exerciseNumber: null,
                                        lectureNumber: null,
                                        comment: null,
                                        course: null
                                    })}
                                />

                            </Table.Cell>
                        </Table.Row>}
                        {this.getDataToRender().length ? this.getDataToRender().map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.orgUnitErr}>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite fakultet"
                                                    value={this.state.orgUnit}
                                                    onChange={this.handleInputChange}
                                                    name="orgUnit"
                                                    options={this.state.orgUnits.filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet')}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.courseBasicNew.organizationalUnit.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field
                                                required
                                                disabled={!this.state.orgUnit}
                                                error={this.state.courseErr}
                                            >
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite predmet"
                                                    value={this.state.course}
                                                    onChange={this.handleInputChange}
                                                    name="course"
                                                    options={this.state.courseBasics}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.courseBasicNew.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.academicYearErr}>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite akademsku godinu"
                                                    value={this.state.academicYear}
                                                    onChange={this.handleInputChange}
                                                    name="academicYear"
                                                    options={this.state.academicYears.filter(year => year.id === this.state.currentAcademicYear)}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field
                                                required
                                                disabled={!this.state.academicYear}
                                                error={this.state.semesterErr}
                                            >
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite semestar"
                                                    value={this.state.semester}
                                                    onChange={this.handleInputChange}
                                                    name="semester"
                                                    options={this.state.semesters}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.semester.name.name + '-' + el.semester.academicYear.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.courseWorkloadTypeErr}>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite zaduzenje"
                                                    value={this.state.courseWorkloadType}
                                                    onChange={this.handleInputChange}
                                                    name="courseWorkloadType"
                                                    options={this.state.workloadTypes}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.courseWorkloadType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.lectureNumberErr}>
                                                <label>P</label>
                                                <input
                                                    value={this.state.lectureNumber}
                                                    onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                                                    name="lectureNumber"
                                                    // type='number'
                                                    placeholder="P"
                                                />
                                            </Form.Field>
                                            <Form.Field required error={this.state.exerciseNumberErr}>
                                                <label>V</label>
                                                <input
                                                    value={this.state.exerciseNumber}
                                                    onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                                                    name="exerciseNumber"
                                                    // type='number'
                                                    placeholder="V"
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.lectureNumber + ' / ' + el.exerciseNumber}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.mandatoryErr}>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite tip predmeta"
                                                    value={this.state.mandatory}
                                                    onChange={this.handleInputChange}
                                                    name="mandatory"
                                                    options={courseTypes}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.mandatory ? 'Obavezni' : 'Izborni'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field
                                                control={Input}
                                                name="comment"
                                                value={this.state.comment}
                                                onChange={this.handleInputChange}
                                                placeholder="Unesite napomenu..."
                                            />
                                        </Form>
                                        : el.comment}
                                </Table.Cell>
                                {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                                <Table.Cell verticalAlign="middle" textAlign="center" colSpan={2}>
                                    {editMode === index ? <div>
                                        <Button
                                            color="blue"
                                            icon="check"
                                            size="small"
                                            circular
                                            onClick={this.edit}
                                        />

                                        <Button
                                            icon="close"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({
                                                editMode: null,
                                                exerciseNumber: null,
                                                lectureNumber: null,
                                                comment: null,
                                                course: null
                                            })}
                                        />
                                    </div>
                                        : <div>
                                            <Button
                                                disabled={this.state.currentAcademicYear !== this.state.academicYearForReport}
                                                color="green"
                                                icon="pencil"
                                                size="small"
                                                basic="true"
                                                circular
                                                onClick={() => {
                                                    this.getSemesters(el.semester.academicYear.id);
                                                    this.getCourseBasic(el.courseBasicNew.organizationalUnit.id);

                                                    this.setState({
                                                        editMode: index,
                                                        addNewWorkload: false,
                                                        comment: el.comment,
                                                        exerciseNumber: el.exerciseNumber,
                                                        lectureNumber: el.lectureNumber,
                                                        mandatory: el.mandatory ? 2 : 1,
                                                        courseWorkloadType: el.courseWorkloadType.id,
                                                        semester: el.semester.id,
                                                        academicYear: el.semester.academicYear.id,
                                                        course: el.courseBasicNew.id,
                                                        orgUnit: el.courseBasicNew.organizationalUnit.id,
                                                        id: el.id,
                                                        optLock: el.optLock
                                                    });
                                                }}
                                            />

                                            <Button
                                                disabled={this.state.currentAcademicYear !== this.state.academicYearForReport}
                                                icon="trash alternate"
                                                size="small"
                                                basic="true"
                                                color="red"
                                                circular
                                                onClick={() => this.deleteWorkload(el.id)}
                                            />
                                        </div>
                                    }
                                </Table.Cell>}
                            </Table.Row>)) : <Table.Row>
                                <Table.Cell
                                colSpan={this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' ? '17' : '15'}
                            >
                                Nema opterećenja za ovog zaposlenika.
                            </Table.Cell></Table.Row>}
                    </Table.Body>

                    {this.state.data.length ? <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell
                                colSpan={this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' ? '10' : '8'}
                                rowSpan="3"
                            />
                            <Table.HeaderCell colSpan="7">
                                <h4> Zimski semestar:</h4>
                                predmeti: <b><i>{this.state.WinterSemesterCourses}</i></b> <br />
                                predavanja: <b><i>{this.state.WinterSemesterLectureNumber}</i></b> &nbsp; <span style={{ color: 'grey' }}> (sati po semestru)</span>
                                &nbsp; / &nbsp; <b><i>{(this.state.WinterSemesterLectureNumber / 15).toFixed(2)}</i></b> &nbsp; <span style={{ color: 'grey' }}> (sati po sedmici)</span> <br />
                                vježbe: <b><i>{this.state.WinterSemesterExerciseNumber}</i></b> &nbsp; <span style={{ color: 'grey' }}>(sati po semestru)</span>
                                &nbsp; / &nbsp; <b><i>{(this.state.WinterSemesterExerciseNumber / 15).toFixed(2)}</i></b> &nbsp; <span style={{ color: 'grey' }}>(sati po sedmici)</span>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan="7">
                                <h4> Ljetni semestar: </h4>
                                predmeti: <b><i>{this.state.SummerSemesterCourses}</i></b> <br />
                                predavanja: <b><i>{this.state.SummerSemesterLectureNumber}</i></b> &nbsp; <span style={{ color: 'grey' }}> (sati po semestru)</span>
                                &nbsp; / &nbsp; <b><i>{(this.state.SummerSemesterLectureNumber / 15).toFixed(2)}</i></b> &nbsp; <span style={{ color: 'grey' }}> (sati po sedmici)</span><br />
                                vježbe: <b><i>{this.state.SummerSemesterExerciseNumber}</i></b>&nbsp; <span style={{ color: 'grey' }}>(sati po semestru)</span>
                                &nbsp; / &nbsp; <b><i>{(this.state.SummerSemesterExerciseNumber / 15).toFixed(2)}</i></b>&nbsp; <span style={{ color: 'grey' }}>(sati po sedmici)</span>

                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan="7">
                                <h4> Ukupno: </h4>
                                predmeti: <b><i>{this.state.SummerSemesterCourses + this.state.WinterSemesterCourses}</i></b> /
                                predavanja: <b><i>{this.state.SummerSemesterLectureNumber + this.state.WinterSemesterLectureNumber}</i></b> /
                                vježbe: <b><i>{this.state.SummerSemesterExerciseNumber + this.state.WinterSemesterExerciseNumber}</i></b>

                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer> : ''}
                </Table>
                <ToastContainer hideProgressBar />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/profile/Workload/Workload.js